import { css, type Theme } from "@emotion/react";

export const dropDown = css`
  width: 100%;
`;

export const searchBarInput = (theme: Theme) => css`
  background-color: ${theme.input.backgroundBase};
`;

export const searchBarBox = (theme: Theme, error: boolean) => css`
  background-color: ${theme.input.backgroundBase};
  border: ${error ? `1px solid ${theme.input.borderError}` : "none"};
  border-bottom: 1px solid ${error ? theme.input.borderError : theme.input.borderEmphasized};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  :hover,
  :active,
  :focus-within,
  :focus {
    border: ${error ? `1px solid ${theme.input.borderError}` : "none"};
    background-color: ${theme.input.backgroundHover};
    box-shadow: none;
    transition-delay: -1s;

    > input {
      background-color: ${theme.input.backgroundHover};
      transition-delay: -1s;
    }
  }
`;

export const dropDownError = (theme: Theme) => css`
  border: 1px solid ${theme.input.borderError};
`;
